import { Chip } from '@components/std-components/Chip'
import Typography from '@components/std-components/Typography'
import ColorCircle from '@components/UI-Components/ChipList/ColorCircle'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import classNames from 'classnames'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import ChipListSkeleton from '../../../CellLoaders/ChipListSkeleton'
import * as css from './CMClusters.css'

const CMClusters: FC<CellItem> = ({ rowData }) =>
  useObserver(function useHook() {
    if (!rowData) {
      return (
        <div>
          <ChipListSkeleton count={3} />
        </div>
      )
    }
    return (
      <div className={css['cluster-container']}>
        {rowData?.clusters?.map(({ id, name, color, status }) => (
          <Chip
            className={css['chip']}
            key={id}
            offset={{ bottom: 12 }}
            tooltip={`${name}${status ? `: ${status}` : ''}`}
          >
            <div className={css['color-item']}>
              <ColorCircle color={color} />
            </div>
            <Typography
              variant='body2'
              color='primary'
              classes={classNames(css['content'], 'text-ellipsis')}
            >
              {name}
              {status ? `: ${status}` : ''}
            </Typography>
          </Chip>
        ))}
      </div>
    )
  })

export default CMClusters
